export default "__VITE_ASSET__CuSB$mu2__"